import AbstractNotifier from '@/utils/Services/Agent/Notifiers/AbstractNotifier';
import NoNotifyPolicy from "@/policies/Proposal/Product/ProductPolicy/NoNotifyPolicy";

export default class NoNotifier extends AbstractNotifier {
    get title() {
        return 'Geen notify';
    }

    get notificationTitle() {
        return 'Handmatig inboeken';
    }

    isSelectable() {
        return true;
    }

    proposalProductPolicy() {
        return NoNotifyPolicy;
    }

    canCancelProduct() {
        return true;
    }
}
